import moment from "moment";
import React from "react";
import { Modal, ModalBody } from "reactstrap";

import { ReactComponent as CloseIcon } from "../../../../../../assets/img/svg/CloseIcon.svg";
import { ReactComponent as DownloadFile } from "../../../../../../assets/img/svg/downloadIcon.svg";
import { openFileInNewWindow } from "../lectureModule/LectureListItem";

const ViewPastEvent = ({ isOpen, onClose, viewLectureData }) => {
  const { classType, lectureStartTime, lectureEndTime } = viewLectureData;
  let content = [];

  const getTime = (date) => {
    return new moment(date).format("hh:mm A");
  };

  const getFormattedDate = (date) => {
    return new moment(date).format("DD MMM YYYY");
  };

  if (["ptm", "orientation"].includes(classType.toLowerCase()))
    content = [
      {
        question: "Date",
        answer: getFormattedDate(lectureStartTime),
      },
      {
        question: "Time",
        answer: `${getTime(lectureStartTime)} - ${getTime(lectureEndTime)}`,
      },
      {
        question: "Room",
        answer: `${viewLectureData.roomName || "-"}`,
      },
      {
        question: "Faculty",
        answer: `${viewLectureData.facultyName || "-"}`,
      },
      {
        question: "MS Teams/GC",
        answer: viewLectureData.msTeam.label,
      },
      {
        question: "Attachment",
        answer: viewLectureData?.documentS3Key ? (
          <DownloadPdfAttachment
            documentS3Key={viewLectureData?.documentS3Key}
          />
        ) : (
          "-"
        ),
      },
    ];
  else if (classType.toLowerCase() === "holiday")
    content = [
      {
        question: "Title",
        answer: viewLectureData.title,
      },
      {
        question: "Date",
        answer:
          moment
            .duration(moment(lectureEndTime).diff(moment(lectureStartTime)))
            .as("days") > 1
            ? `${getFormattedDate(lectureStartTime)} - ${getFormattedDate(
                lectureEndTime
              )}`
            : `${getFormattedDate(lectureStartTime)}`,
      },
    ];
  else if (classType.toLowerCase() === "break")
    content = [
      {
        question: "Date",
        answer: getFormattedDate(lectureStartTime),
      },
      {
        question: "Time",
        answer: `${getTime(lectureStartTime)} - ${getTime(lectureEndTime)}`,
      },
      {
        question: "Room",
        answer: viewLectureData.roomName || "-",
      },
    ];
  else
    content = [
      {
        question: "Date",
        answer: getFormattedDate(lectureStartTime),
      },
      {
        question: "Time",
        answer: `${getTime(lectureStartTime)} - ${getTime(lectureEndTime)}`,
      },
      {
        question: "Subject",
        answer: viewLectureData.subject,
      },
      {
        question: "Lecture Name",
        answer: viewLectureData.lectureName,
      },
      {
        question: "Faculty",
        answer: viewLectureData.facultyName,
      },
      {
        question: "Room",
        answer: viewLectureData.roomName,
      },
    ];

  return (
    <Modal
      size="lg"
      isOpen={isOpen}
      toggle={onClose}
      style={{ width: "500px" }}
    >
      <ModalBody>
        <div className="d-flex justify-content-between align-items-start mb-1">
          <div className="heading-4 label-color text-bold">{classType}</div>
          <CloseIcon onClick={() => onClose()} />
        </div>

        {content.map(({ question, answer }, index) => (
          <div className="mt-3" key={index}>
            <span className="regular-large-bold text-bold color-dark">
              {question}:{" "}
            </span>
            {answer}
          </div>
        ))}
      </ModalBody>
    </Modal>
  );
};

export default ViewPastEvent;

const DownloadPdfAttachment = ({ documentS3Key }) => {
  const onClick = () => {
    openFileInNewWindow(documentS3Key);
  };

  return (
    <div style={{ cursor: "pointer", display: "inline" }}>
      <DownloadFile onClick={onClick} />
    </div>
  );
};
